import { render } from "./ProfileQuickMenu.vue?vue&type=template&id=53370bfc&scoped=true"
import script from "./ProfileQuickMenu.vue?vue&type=script&lang=js"
export * from "./ProfileQuickMenu.vue?vue&type=script&lang=js"

import "./ProfileQuickMenu.vue?vue&type=style&index=0&id=53370bfc&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53370bfc"]])

export default __exports__